(function () {
  if (window.__apSubscriptionEducationInitialized) return;
  window.__apSubscriptionEducationInitialized = true;

  function selectedVariantId(link) {
    var scope = link.closest('section') || document;
    var selected = scope.querySelector('[data-ap-variant]:checked, [data-apsub2-variant]');

    if (selected && selected.dataset.apsub2Variant) return selected.dataset.apsub2Variant;
    if (selected && selected.value) return selected.value;

    selected = document.querySelector(
      '[data-ap-variant]:checked, form[action*="/cart/add"] [name="id"]:checked, form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"][type="hidden"]'
    );
    return selected && selected.value ? selected.value : link.dataset.apSubVariant;
  }

  function updateLink(link) {
    var url = new URL(link.href, window.location.origin);
    var variantId = selectedVariantId(link);
    if (variantId) {
      url.searchParams.set('variant', variantId);
      link.dataset.apSubVariant = variantId;
    }
    link.href = url.pathname + url.search;
    return variantId;
  }

  function track(link, variantId) {
    if (typeof window.apTrack !== 'function') return;
    window.apTrack('subscription_education_clicked', {
      product_id: link.dataset.apSubProduct,
      product_handle: link.dataset.apSubHandle,
      variant_id: variantId,
      product_family: link.dataset.apSubFamily,
      placement: link.dataset.apSubPlacement
    }, 'subscription');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ap-sub-education]');
    if (!link) return;
    track(link, updateLink(link));
  });

  function restoreSubscriptionMode() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('purchase') !== 'sub') return;

    var subscriptionInput = document.querySelector(
      '[data-ap-subscribe-option] input[type="radio"], [data-apsub2-mode-input][value="sub"]'
    );
    if (subscriptionInput && !subscriptionInput.checked) subscriptionInput.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreSubscriptionMode, { once: true });
  } else {
    restoreSubscriptionMode();
  }
}());
